module.exports = __webpack_public_path__ + "img/img_2.fe1bc4ee.png";